var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fa-icon',{staticClass:"spinner",staticStyle:{"--fa-animation-duration":"1s"},attrs:{"icon":"fa-circle-notch","size":"xl","spin":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }